
import Vue from "vue";
export default Vue.extend({
  name: "AffiliateCard",
  props: {
    affiliate: Object,
  },
});
